import React from 'react';

export default function TabelaPadrao({ columns, data, loading, emptyMessage }) {
  if (loading) {
    return (
      <div style={{ color: 'var(--muted)', padding: '24px', textAlign: 'center', fontSize: 'var(--font-base)' }}>
        Carregando...
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div style={{ color: 'var(--dim)', padding: '24px', textAlign: 'center', fontSize: 'var(--font-sm)' }}>
        {emptyMessage || 'Sem dados'}
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: 'var(--font-sm)',
      }}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                style={{
                  textAlign: col.align || 'left',
                  padding: '10px 16px',
                  borderBottom: '1px solid var(--border)',
                  color: 'var(--muted)',
                  fontWeight: 600,
                  fontSize: 'var(--font-xs)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  whiteSpace: 'nowrap',
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={row.id || idx}>
              {columns.map((col) => (
                <td
                  key={col.key}
                  style={{
                    textAlign: col.align || 'left',
                    padding: '10px 16px',
                    borderBottom: '1px solid var(--border)',
                    color: 'var(--text)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
